import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHourglass } from "@fortawesome/free-solid-svg-icons";

const iconHourglass = <FontAwesomeIcon icon={faHourglass} color="#aa9b73" size="sm" />;

export default iconHourglass;
